import React from "react";

import SearchSectionComponent from "../../components/SearchSectionComponent";
import "./HelpCenterPage.scss";
import {request} from '../../services/BackendService';
import {Helmet} from "react-helmet";
import mixpanel from "mixpanel-browser";
import InquiryFormComponent from "../../components/InquiryFormComponent";
import FaqComponent from "../../components/FaqComponent";

export default class HelpCenterPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            faq: []
        }
    }

    componentDidMount() {
        this.getFaq();
        // Track page visit with Mixpanel
        mixpanel.track('Visited Help Center Page');
    }

    getFaq = async () => {
        const response = await request('/getFaq');
        this.setState({faq: response.data});
    }
    
    // Convert markdown content to HTML with links - using the original implementation
    convertMarkdownToHTML = (markdownContent) => {
        if (!markdownContent) return '';
        
        // Replace double underscores for bold text with HTML <strong> tags
        let htmlContent = markdownContent.replace(/__([^_]+)__/g, '<strong>$1</strong>');

        // Replace markdown links with HTML anchor tags
        htmlContent = htmlContent.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

        // Split content by newlines and wrap each paragraph in <p> tags
        const paragraphs = htmlContent.split('\n');
        
        // If there's only one paragraph, just wrap it
        if (paragraphs.length === 1) {
            return `<p>${paragraphs[0]}</p>`;
        }
        
        // Join multiple paragraphs with proper <p> tags
        return paragraphs.map(para => `<p>${para}</p>`).join('');
    }

    render() {
        return(
            <div className="HelpCenterPafe content">
                <Helmet>
                    <title>Help Center and FAQ | Pickup Hungary</title>
                    <meta
                        name="description"
                        content="Any questions about using Pickup Hungary, your booking or your ride? Pickup Hungary customer support is here to help you."
                    />

                    <meta
                        name="keywords"
                        content="FAQ about airport transfer, How to book transfer, What about luggage, need a child seat, Transfer booking, bulky luggage, flight is delayed, travelling with animal"
                    />
                </Helmet>
                
                <SearchSectionComponent />
    
                <div className="bg-gray">
                    <div className="container-lg pt-5 pb-5">
                        <h1 className="text-center text-uppercase font-weight-bold">Help Center</h1>
                    </div>
                </div>
    
                {/* FAQ Section */}
                {this.state.faq.length > 0 && (
                    <FaqComponent 
                        title="Frequently Asked Questions"
                        faqs={this.state.faq.map(faq => ({
                            question: faq.name,
                            answer: this.convertMarkdownToHTML(faq.answer)
                        }))}
                    />
                )}
    
                {/* Contact Form Section */}
                <InquiryFormComponent 
                    title="Contact Us"
                    subtitle="If you can't find the answer for your question, you are more than welcome to contact us."
                    features={[
                        "Quick response within 2 hours",
                        "24/7 customer support",
                        "Personalized assistance",
                        "Booking modifications",
                        "Special requests"
                    ]}
                    defaultMessage="Hello, I have a question about your services."
                    bookingReference="Help Center Inquiry"
                    includeWhatsApp={true}
                    section="help-center-page"
                />

                {/* Company Contact Information */}
                <section className="company-contact">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-10 offset-lg-1">
                                <div className="contact-card">
                                    <h2 className="section-title">Company Information</h2>
                                    
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="contact-group">
                                                <h3><i className="fa fa-building"></i> Legal Entity</h3>
                                                <div className="contact-item">
                                                    <div className="contact-info">
                                                        <p>Spa Thermal Travel Kft.</p>
                                                        <p>Company Registration Number: 14 09 314248</p>
                                                        <p>VAT Number: HU24958952</p>
                                                        <p>License Number: U-001568</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-6">
                                            <div className="contact-group">
                                                <h3><i className="fa fa-map-marker"></i> Address</h3>
                                                <div className="contact-item">
                                                    <div className="contact-info">
                                                        <p>1124 Budapest, Kiss János altábornagy utca 55-59., Hungary</p>
                                                    </div>
                                                </div>
                                                
                                                <h3 className="mt-4"><i className="fa fa-envelope"></i> Contact Us</h3>
                                                <div className="contact-item">
                                                    <div className="contact-info">
                                                        <p><strong>Email:</strong> <a href="mailto:info@pickuphungary.com">info@pickuphungary.com</a></p>
                                                        <p><strong>WhatsApp:</strong> <a href="https://wa.me/36707177656" target="_blank" rel="noreferrer">+36 70 717 7656</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="payment-methods">
                                        <p>Accepted Payment Methods:</p>
                                        <img 
                                            src="/images/Barion-card-payment-mark-2017-400px.webp" 
                                            alt="Accepted payment methods: Visa, Mastercard, Maestro, Amex" 
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
            </div>
        );
    }
}
